import { render, staticRenderFns } from "./CheckboxSelectForm.vue?vue&type=template&id=c213723c"
import script from "./CheckboxSelectForm.vue?vue&type=script&lang=js"
export * from "./CheckboxSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports